import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import styles from "./index.module.scss";
import PrevSVG from "./images/prev.svg";
import NextSVG from "./images/next.svg";
import DownloadSVG from "./images/download.svg";
import VideoPlayer from "../../../VideoPlayer";
import { track } from "../../../../../../utils/amplitude";

export default function Carousel(props) {
  const { data = [], fullImg, fullImgState } = props;
  const [ref, api] = useEmblaCarousel({
    skipSnaps: false,
  });
  const [refThumb, apiThumb] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
  });
  const [selected, setSelected] = useState(0);
  const [stopVideo, setStopVideo] = useState(false);
  const images = data.flat(1);
  const onPreviousHandler = () => {
    api.scrollPrev();
  };
  const onNextHandler = () => {
    api.scrollNext();
  };
  const onSelectHandler = (key) => {
    api.scrollTo(key);
  };
  useEffect(() => {
    const callback = () => {
      const index = api.selectedScrollSnap();
      apiThumb.scrollTo(index);
      setSelected(index);
    };
    api?.on("select", callback);
    return () => {
      api?.off("select", callback);
    };
  }, [api]);

  const imgClickFunck = () => {
    if (!stopVideo) setStopVideo(true);

    if (fullImg) {
      // let key = selected.;
      // fullImg(key ? key : true);
      fullImg({ key: selected, data: data });
      document.body.style.overflow = "hidden";
    }
  };
  useEffect(() => {
    if (!fullImgState) setStopVideo(false);
  }, [fullImgState]);

  return (
    <>
      <div className={styles.root}>
        <div className={styles.wrapper} ref={ref}>
          <div className={styles.carousel_container}>
            {images.map((img, key, i) => (
              <div className={styles.slide} key={key} onClick={imgClickFunck}>
                {img.type === "video" && selected === key ? (
                  <VideoPlayer
                    src={img?.src}
                    img={img?.url}
                    stopVideo={stopVideo}
                  />
                ) : (
                  <img
                    src={img.url?.thumb}
                    width="280"
                    height="606"
                    alt={img.id}
                    loading="lazy"
                  />
                )}
              </div>
            ))}
          </div>
          <button
            className={`${styles.control} ${styles.prev}`}
            onClick={onPreviousHandler}
          >
            <PrevSVG />
          </button>
          <button
            className={`${styles.control} ${styles.next}`}
            onClick={onNextHandler}
          >
            <NextSVG />
          </button>
        </div>
        <div className={styles.actions} type="button">
          <a
            href={images[0].src}
            download
            onClick={() => track("paywall_gallery_item_download_link_clicked")}
          >
            <DownloadSVG />
          </a>
        </div>
      </div>
      <div className={styles.root}>
        <div className={styles.thumbnail_wrapper} ref={refThumb}>
          <div className={styles.thumbnails}>
            {images.map((img, key) =>
              img.type === "video" ? (
                <div
                  onClick={() => onSelectHandler(key)}
                  className={`${styles.thumb} ${
                    key === selected && styles.active
                  }`}
                >
                  <img
                    width="58"
                    height="144"
                    src={img.url}
                    alt={img.id}
                    loading="lazy"
                  />
                </div>
              ) : (
                <div
                  className={`${styles.thumb} ${
                    key === selected && styles.active
                  }`}
                  key={key}
                  onClick={() => onSelectHandler(key)}
                >
                  <img
                    width="58"
                    height="144"
                    src={img.url.small}
                    alt={img.id}
                    loading="lazy"
                  />
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
}
